import { render } from "./user-limit-info-block.vue?vue&type=template&id=e8c7932a&lang=pug"
import script from "./user-limit-info-block.vue?vue&type=script&lang=js"
export * from "./user-limit-info-block.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__